import React from 'react'
import { render } from 'react-dom'
import ReactResizeDetector from 'react-resize-detector'
import { CacheProvider } from '@emotion/react'
import { PAYPAL_THEME, ThemeWrapper } from '@paypalcorp/pp-react'
import createCache from '@emotion/cache'
import { ContextProvider as WorldReadyContextProvider } from '@paypalcorp/worldready-react'

import ErrorBoundary from 'components/ErrorBoundary'
import { ModalContextProvider } from 'contexts/ModalContext/ModalContext'
import { isTest } from 'constants/environment'
import {
  SHOPPING_OFFER_DEAL_DETAIL_DISMISS_PRESSED,
  SAVED_TAB_SOURCE
} from 'lib/client-constants'
import OfferDetailsModalHandler from 'shoplist-app/shopping/components/v2/OfferDetailsModalHandler'
import GoldStoreTermsModalHandler from 'shoplist-app/shopping/components/v2/GoldStoreTermsModalHandler/GoldStoreTermsModalHandler'

import clientData, { init as initClientData } from './lib/client-data'
import { initWorldReady } from './lib/initWorldReady'
import PortalFooter from './shoplist-app/shopping/components/v2/PortalFooter'
import ResizeObserverContext from './lib/resize-observer-context'
import SavedOffersPage from './views/Shopping/pages/SavedOffersPage'
import ErrorFallback from 'views/Shopping/components/ErrorFallback'
import { RecentSearchesProvider } from './contexts/RecentSearchesContext/RecentSearchesContext'

initClientData()
initWorldReady(clientData.worldReady, isTest())

render(
  <WorldReadyContextProvider locale={clientData.locality.locale}>
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <CacheProvider
        value={createCache({ key: 'saved-offers', prepend: true })}
      >
        <ReactResizeDetector handleWidth>
          {({ width }: { width: number }) => (
            <ResizeObserverContext.Provider value={width}>
              <div id="resize-observer">
                <ThemeWrapper theme={PAYPAL_THEME}>
                  <RecentSearchesProvider>
                    <ModalContextProvider>
                      <OfferDetailsModalHandler
                        fptiSource={SAVED_TAB_SOURCE}
                        fptiCloseEvent={
                          SHOPPING_OFFER_DEAL_DETAIL_DISMISS_PRESSED
                        }
                      />
                      <GoldStoreTermsModalHandler
                        fptiSource={SAVED_TAB_SOURCE}
                      />
                      <SavedOffersPage />
                      <PortalFooter />
                    </ModalContextProvider>
                  </RecentSearchesProvider>
                </ThemeWrapper>
              </div>
            </ResizeObserverContext.Provider>
          )}
        </ReactResizeDetector>
      </CacheProvider>
    </ErrorBoundary>
  </WorldReadyContextProvider>,
  document.getElementById('root')
)
